import React, { useEffect } from 'react';
import styles from './Pricing.module.css';
import { FaDesktop, FaCalendarCheck, FaPhoneAlt, FaGift } from 'react-icons/fa';
import { GlowEffect } from './ui/GlowEffect';
import { getCalApi } from "@calcom/embed-react";


// Generic Cal.com button component
function CalDemoButton({ calNamespace, calLink, calConfig, children, className }) {
  useEffect(() => {
    (async function () {
      const cal = await getCalApi({ namespace: calNamespace });
      cal("ui", calConfig);
    })();
    // Only run once per mount (button will always work)
    // eslint-disable-next-line
  }, []);
  return (
    <button
      data-cal-namespace={calNamespace}
      data-cal-link={calLink}
      data-cal-config={JSON.stringify(calConfig)}
      className={className}
    >
      {children}
    </button>
  );
}

// --- ServiceCard with Cal.com button ---
const ServiceCard = ({
  icon,
  title,
  monthlyPrice,
  frequency,
  setupFee,
  features,
  note,
  calNamespace,
  calLink,
  calConfig,
  buttonClassName,
  glowcolors
}) => {
  return (
    <div className={styles.cardWrapper}>

      <GlowEffect
        colors={glowcolors}
        mode="static"
        blur="medium"
      />
      <div className={styles.card}>
        <div className={styles.iconWrapper}>{icon}</div>
        <h3>{title}</h3>
        <div className={styles.priceWrapper}>
          <p className={styles.price}><span>$</span>{monthlyPrice}<span>/ {frequency}</span></p>
          <p className={styles.setupFee}>+ {setupFee} one-time setup fee</p>
        </div>
        <ul className={styles.features}>
          {features.map((feature, index) => <li key={index}>{feature}</li>)}
        </ul>
        {note && <p className={styles.note}>{note}</p>}
        <CalDemoButton
          calNamespace={calNamespace}
          calLink={calLink}
          calConfig={calConfig}
          className={buttonClassName}
        >
          Schedule a Demo
        </CalDemoButton>
      </div>
    </div>
  );
};

const Pricing = () => {
  // Example: you can customize each link/config per service
  const calConfig = {
    cssVarsPerTheme: {
      light: { "cal-brand": "#9441d4" },
      dark: { "cal-brand": "#e7ccff" }
    },
    hideEventTypeDetails: false,
    layout: "month_view"
  };

  return (
    <section id="pricing" className={styles.pricing}>
      <h2>Simple Pricing for Everything You Need</h2>
      <p className={styles.subheading}>Get your professional website and smart scheduling system. Choose individual services or save with both together.</p>


      <div className={styles.individualServicesGrid}>
        <ServiceCard
          icon={<FaDesktop size={40} />}
          title="AI-Generated Website"
          monthlyPrice="19"
          frequency="month"
          setupFee="$100 - $200*"
          features={[
            'Beautiful, professional website built by AI',
            'Fully responsive and mobile-optimized',
            'Showcases your services & teaching style',
            'SEO optimized for local search',
            'Hosting and maintenance included'
          ]}
          note="*Setup is $100 with existing website, $200 for brand new website."
          calNamespace="ai-website-demo"
          calLink="musicteachersai/ai-website-demo"
          calConfig={calConfig}
          buttonClassName={styles.ctaButton}
          glowcolors={["#2AF598", "#22E4AC", "#1BD7BB"]}
        />
        <ServiceCard
          icon={<FaCalendarCheck size={40} />}
          title="Smart Scheduling System"
          monthlyPrice="24"
          frequency="month"
          setupFee="$75 - $150*"
          features={[
            '24/7 online booking for students',
            'Syncs with Google Calendar automatically',
            'Prevents double-booking conflicts',
            'Automated email reminders',
            'Easy integration with any website'
          ]}
          note="*Setup is $75 for 0-10 students, $120 for 11-20 students, $150 for 21 or more students"
          calNamespace="integrated-scheduler-demo"
          calLink="musicteachersai/integrated-scheduler-demo"
          calConfig={calConfig}
          buttonClassName={styles.ctaButton}
          glowcolors={["#14C9CB", "#0FBED8", "#08B3E5"]}
        />
      </div>


    </section>
  );
};

export default Pricing;